import {Sticker} from "./Sticker";

export default [
    new Sticker({
        image: require('./assets/stickers/penguin_birthday.svg'),
        width: 2221,
        height: 2962,
        faceTop: 1100,
        faceLeft: 200,
        faceRight: 2221,
        faceBottom: 2962
    }),
    new Sticker({
        image: require('./assets/stickers/penguin_bowtie.svg'),
        width: 2029,
        height: 3037,
        faceTop: 700,
        faceLeft: 0,
        faceRight: 2029,
        faceBottom: 2600
    }),
    new Sticker({
        image: require('./assets/stickers/penguin_crown.svg'),
        width: 2150,
        height: 2789,
        faceTop: 1000,
        faceLeft: 20,
        faceRight: 2050,
        faceBottom: 2789
    }),
    new Sticker({
        image: require('./assets/stickers/penguin_fancy.svg'),
        width: 2732,
        height: 2989,
        faceTop: 1000,
        faceLeft: 350,
        faceRight: 2370,
        faceBottom: 2989
    }),
    new Sticker({
        image: require('./assets/stickers/penguin_hat.svg'),
        width: 2381,
        height: 2734,
        faceTop: 800,
        faceLeft: 350,
        faceRight: 2381,
        faceBottom: 2734
    }),
    new Sticker({
        image: require('./assets/stickers/penguin_winter.svg'),
        width: 2441,
        height: 2666,
        faceTop: 900,
        faceLeft: 0,
        faceRight: 2000,
        faceBottom: 2666
    })
]